import Vue from "vue";
import Loading from "./index.vue";
const Instance = Vue.extend(Loading);

const directive = {
  bind: function(el, binding) {
    const div = document.createElement("div");

    el.appendChild(div);
    el.instance = new Instance({
      el: div,
      data: {
        visible: binding.value,
      },
    });
  },
  unbind: function(el) {
    el.instance &&
      el.instance.parentNode &&
      el.instance.parentNode.removeChild(el.mask);
    el.instance && el.instance.$destroy();
  },
  update: function(el, binding) {
    el.instance.visible = binding.value;
  },
};

Loading.install = function(vm) {
  vm.component("Loading", Loading);
  vm.directive("loading", directive);
};
export default Loading;
